var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#979592;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,2c12.1,0,22,9.9,22,22s-9.9,22-22,22S2,36.1,2,24S11.9,2,24,2 M24,0C10.7,0,0,10.7,0,24s10.7,24,24,24 s24-10.7,24-24S37.3,0,24,0L24,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,10.1c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.6,8.2,8,8.2c0,0,0.1,0,0.1,0c4.5,0,8.2-3.6,8.2-8.2 C32.2,13.8,28.5,10.1,24,10.1C24,10.1,24,10.1,24,10.1L24,10.1z M24,25.2C24,25.2,24,25.2,24,25.2c-4,0-7.1-3.2-7-7 c0.1-3.8,3.2-6.8,7-6.8c0,0,0,0,0.1,0c3.8,0,6.9,3.2,6.9,7C30.9,22,27.8,25.2,24,25.2L24,25.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,27.8c-1.2,0-2.3,0-3.5,0c0,0,0,0,0,0c-1.2,0-2.4,0-3.6,0c-0.7,0-1.4,0-2.2,0c-3.7,0.1-6.6,2.7-7,6.2 c0,0.4,0.3,0.9,0.4,1.4c0.3-0.4,0.7-0.7,0.8-1.1c0.5-3.1,2.7-5.2,5.8-5.2c1.8,0,3.7,0,5.5,0c2,0,4,0,6,0.1 c2.9,0.1,5.1,2.1,5.6,4.9c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.4,0.5,0.5,0.5c0,0,0,0,0,0c0.3-0.1,0.5-0.4,0.6-0.6c0.1-0.3,0-0.7,0-1 c-0.5-3.4-3.4-5.9-6.9-6C29,27.9,28.3,27.8,27.5,27.8L27.5,27.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/UserAvatar.a8e4669bc7ac6dad7748cf16c9264a7a.svg";
export { ForwardRef as ReactComponent };